import Kpi from "../fuel_report/kpi_main";

const Dashboard = () => {
  return <Kpi />;
};

export default Dashboard;